const ui = (function() {

    // ── Helpers ──────────────────────────────────────────────────────────────

    function groupByProduct(items) {
        const map = new Map();
        items.forEach(item => {
            const key = item.metafields.product || item.title;
            if (!map.has(key)) {
                map.set(key, { key, variants: [], image: item.image, price: item.price });
            }
            const g = map.get(key);
            g.variants.push(item);
            if (item.price < g.price) g.price = item.price;
            if (!g.image && item.image) g.image = item.image;
        });
        return Array.from(map.values());
    }

    function getUnique(items, field) {
        return [...new Set(items.map(i => i.metafields[field]).filter(Boolean))].sort();
    }

    // ── Strap Step ───────────────────────────────────────────────────────────

    function renderStrapStep() {
        const allStraps = api._cache.straps || [];
        
        // 外层：默认选中第一个可用材质
        const currentMaterial = state.getState().strapMaterial;
        if (!currentMaterial) {
            const materials = state.getState().isDouble ? OUT_MATERIALS : ALL_MATERIALS;
            const firstMat = materials.find(m => !DISABLED_MATERIALS.includes(m));
            if (firstMat) {
                state.setState('strapMaterial', firstMat);
                filter._setStrapMaterialFilterSilent(firstMat);
            }
        }
        
        renderMaterialTypeGrid(allStraps);
        renderStrapColorCards(filter.getFilteredStraps());

        // 内层材质网格（双层时才有效）
        const innerGrid = document.getElementById('inner-strap-material-type-grid');
        if (innerGrid) {
            renderInnerMaterialTypeGrid(allStraps);
            renderInnerStrapColorCards(filter.getFilteredInnerStraps());
        }
    }

    // 按颜色展示变体卡片（不再按 product 分组）
    function renderStrapColorCards(items) {
        const container = document.getElementById('strap-list');
        if (!container) return;
        
        if (!items || items.length === 0) {
            container.innerHTML = '<div class="empty-state">No straps found</div>';
            return;
        }

        let html = '';
        items.forEach(variant => {
            const hasStock = variant.available !== false;
            const imgSrc = variant.image || '';
            const colorName = variant.metafields.strap_color || variant.title;
            const priceDisplay = variant.price > 0 ? '$' + variant.price.toFixed(2) : '-';

            html += `
                <div class="product-card" data-variant-id="${variant.id}">
                    <div class="product-image-wrapper">
                        ${imgSrc
                            ? `<img src="${imgSrc}" alt="${colorName}" class="product-image" loading="lazy"/>`
                            : `<div class="product-image-placeholder"></div>`}
                        ${!hasStock ? '<div class="product-badge-oos">Out of Stock</div>' : ''}
                    </div>
                    <div class="product-info">
                        <h4 class="product-title">${colorName}</h4>
                        <p class="product-price">${priceDisplay}</p>
                    </div>
                </div>
            `;
        });

        container.innerHTML = html;

        container.querySelectorAll('.product-card').forEach(card => {
            card.addEventListener('click', function() {
                const variantId = this.dataset.variantId;
                const variant = items.find(v => String(v.id) === variantId);
                if (!variant || variant.available === false) return;

                document.querySelectorAll('.product-card').forEach(c => c.classList.remove('selected'));
                this.classList.add('selected');

                // 长度已在步骤1选好，直接记录变体信息
                builder.selectStrap(variant);
            });
        });
    }

    //单层带条
    const ALL_MATERIALS = [
        // 'Bridle Leather',  //马缰
        'J&E Bridle Leather', //J&E马缰
        'J&F Bridle Leather', //JF马缰
        'TWS Bridle Leather', //TWS马缰
        'Tochigi Leather',  //栃木
        'Shonan Leather',  //昭南
        'Saddle Leather',  //美鞍
        'Italian Leather',  //意大利
    ];
    //双层带条
    //外层
    const OUT_MATERIALS = [
      'Shipwreck Leather',   //沉船
      'Black Diamond Leather',  //黑栈
    //   'Shell Cordovan',  //新禧马臀
      'Tochigi Leather',  //栃木
      // 'Bridle Leather',   //马缰
      'J&E Bridle Leather', //J&E马缰
      'J&F Bridle Leather', //JF马缰
      'TWS Bridle Leather', //TWS马缰
      'Italian Leather',  //意大利
      // 'Nile Crocodile',  //尼罗鳄
      // 'American Alligator',  //美洲鳄
      // 'Saltwater Crocodile'  //湾鳄
    ];
    //内层
    const INNER_MATERIALS = [
      'Italian Leather',  //意大利
      'TWS Bridle Leather', //TWS马缰
      'Tochigi Leather',  //栃木
    ];


    // Materials that are not yet available
    // const DISABLED_MATERIALS = ['Nile Crocodile', 'American Alligator', 'Saltwater Crocodile'];
    const DISABLED_MATERIALS = [];

    // Material display photos - upload these files to Shopify Files (Content > Files)
    const MATERIAL_IMAGES = window.materialImages || {};

    function getMaterialListForCurrentLayer() {
        return state.getState().isDouble ? OUT_MATERIALS : ALL_MATERIALS;
    }

    function renderMaterialTypeGrid(allStraps) {
        const container = document.getElementById('strap-material-type-grid');
        if (!container) return;

        const currentMaterial = state.getState().strapMaterial;
        const materials = getMaterialListForCurrentLayer();

        container.innerHTML = materials.map(mat => {
            const isDisabled = DISABLED_MATERIALS.includes(mat);
            const isSelected = currentMaterial === mat && !isDisabled;
            const imgSrc = MATERIAL_IMAGES[mat] || '';
            const imgHtml = imgSrc
                ? `<img src="${imgSrc}" alt="${mat}" class="material-type-img" loading="lazy"/>`
                : `<div class="material-type-swatch"></div>`;

            return `
                <div class="material-type-card ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}"
                     data-material="${mat}" ${isDisabled ? 'aria-disabled="true"' : ''}>
                    ${imgHtml}
                    <span class="material-type-name">${mat}</span>
                    ${isDisabled ? '<span class="material-coming-soon">Coming Soon</span>' : ''}
                </div>`;
        }).join('');

        container.querySelectorAll('.material-type-card:not(.disabled)').forEach(card => {
            card.addEventListener('click', function() {
                container.querySelectorAll('.material-type-card').forEach(c => c.classList.remove('selected'));
                this.classList.add('selected');
                const mat = this.dataset.material;
                state.setState('strapMaterial', mat);
                filter.setStrapMaterialFilter(mat);
                renderStrapColorCards(filter.getFilteredStraps());
            });
        });
    }

    // ── 内层带条 ─────────────────────────────────────────────────────────────

    function renderInnerMaterialTypeGrid(allStraps) {
        const container = document.getElementById('inner-strap-material-type-grid');
        if (!container) return;

        // 内层：默认选中第一个可用材质
        let currentMaterial = state.getState().innerStrapMaterial;
        if (!currentMaterial) {
            const firstMat = INNER_MATERIALS.find(m => !DISABLED_MATERIALS.includes(m));
            if (firstMat) {
                currentMaterial = firstMat;
                state.setState('innerStrapMaterial', firstMat);
                if (typeof filter._setInnerStrapMaterialFilterSilent === 'function') {
                    filter._setInnerStrapMaterialFilterSilent(firstMat);
                } else {
                    filter.setInnerStrapMaterialFilter(firstMat);
                }
            }
        }
        container.innerHTML = INNER_MATERIALS.map(mat => {
            const isDisabled = DISABLED_MATERIALS.includes(mat);
            const isSelected = currentMaterial === mat && !isDisabled;
            const imgSrc = MATERIAL_IMAGES[mat] || '';
            const imgHtml = imgSrc
                ? `<img src="${imgSrc}" alt="${mat}" class="material-type-img" loading="lazy"/>`
                : `<div class="material-type-swatch"></div>`;

            return `
                <div class="material-type-card inner-material-card ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}"
                     data-material="${mat}" ${isDisabled ? 'aria-disabled="true"' : ''}>
                    ${imgHtml}
                    <span class="material-type-name">${mat}</span>
                    ${isDisabled ? '<span class="material-coming-soon">Coming Soon</span>' : ''}
                </div>`;
        }).join('');

        container.querySelectorAll('.inner-material-card:not(.disabled)').forEach(card => {
            card.addEventListener('click', function() {
                container.querySelectorAll('.inner-material-card').forEach(c => c.classList.remove('selected'));
                this.classList.add('selected');
                const mat = this.dataset.material;
                state.setState('innerStrapMaterial', mat);
                filter.setInnerStrapMaterialFilter(mat);
                renderInnerStrapColorCards(filter.getFilteredInnerStraps());
            });
        });
    }

    function renderInnerStrapColorCards(items) {
        const container = document.getElementById('inner-strap-list');
        if (!container) return;

        if (!items || items.length === 0) {
            container.innerHTML = '<div class="empty-state">No straps found</div>';
            return;
        }

        let html = '';
        items.forEach(variant => {
            const hasStock = variant.available !== false;
            const imgSrc = variant.image || '';
            const colorName = variant.metafields.strap_color || variant.title;
            const priceDisplay = variant.price > 0 ? '$' + variant.price.toFixed(2) : '-';

            html += `
                <div class="product-card inner-strap-card" data-variant-id="${variant.id}">
                    <div class="product-image-wrapper">
                        ${imgSrc ? `<img src="${imgSrc}" alt="${colorName}" class="product-image" loading="lazy"/>` : `<div class="product-image-placeholder"></div>`}
                        ${!hasStock ? '<div class="product-badge-oos">Out of Stock</div>' : ''}
                    </div>
                    <div class="product-info">
                        <h4 class="product-title">${colorName}</h4>
                        <p class="product-price">${priceDisplay}</p>
                    </div>
                </div>`;
        });

        container.innerHTML = html;

        container.querySelectorAll('.inner-strap-card').forEach(card => {
            card.addEventListener('click', function() {
                const variantId = this.dataset.variantId;
                const variant = items.find(v => String(v.id) === variantId);
                if (!variant || variant.available === false) return;

                container.querySelectorAll('.inner-strap-card').forEach(c => c.classList.remove('selected'));
                this.classList.add('selected');

                builder.selectInnerStrap(variant);
            });
        });
    }

    // ── Buckle Step ──────────────────────────────────────────────────────────

    // 固定的扣头类型列表
    const ALL_BUCKLE_TYPES = [
        'Pin Buckles',
        'Plate Buckles',
        'Automatic Buckles',
    ];

    function renderBuckleStep() {
        const allBuckles = api._cache.buckles || [];

        const currentType = state.getState().buckleType;
        if (!currentType) {
            state.setState('buckleType', 'Pin Buckles');
            filter._setBuckleTypeFilterSilent('Pin Buckles');
        }

        renderBuckleTypeGrid(allBuckles);
        renderBuckleMaterialFilter(allBuckles);
        renderBuckleInstallationControl();
        renderBuckleList(filter.getFilteredBuckles());
    }

    function renderBuckleInstallationControl() {
        const container = document.getElementById('buckle-installation-control');
        if (!container) return;

        const current = state.getState().buckleInstallation || '';
        container.querySelectorAll('.installation-btn').forEach(btn => {
            if (btn.dataset.install === current) btn.classList.add('selected'); else btn.classList.remove('selected');
            btn.addEventListener('click', function() {
                container.querySelectorAll('.installation-btn').forEach(b => b.classList.remove('selected'));
                this.classList.add('selected');
                const method = this.dataset.install || '';
                state.setState('buckleInstallation', method);
                if (typeof filter.setBuckleInstallationFilter === 'function') {
                    filter.setBuckleInstallationFilter(method);
                    renderBuckleList(filter.getFilteredBuckles());
                }
            });
        });
    }

    // 扣头类型图片映射
    const BUCKLE_TYPE_IMAGES = window.buckleTypeImages || {};

    function renderBuckleTypeGrid(allBuckles) {
        const container = document.getElementById('buckle-type-grid');
        if (!container) return;

        const currentType = state.getState().buckleType;

        container.innerHTML = ALL_BUCKLE_TYPES.map(t => {
            const imgSrc = BUCKLE_TYPE_IMAGES[t] || '';
            const imgHtml = imgSrc
                ? `<img src="${imgSrc}" alt="${t}" class="material-type-img"/>`
                : `<div class="material-type-swatch buckle-swatch"></div>`;
            return `
                <div class="material-type-card ${currentType === t ? 'selected' : ''}" data-type="${t}">
                    ${imgHtml}
                    <span class="material-type-name">${t}</span>
                </div>`;
        }).join('');

        container.querySelectorAll('.material-type-card').forEach(card => {
            card.addEventListener('click', function() {
                container.querySelectorAll('.material-type-card').forEach(c => c.classList.remove('selected'));
                this.classList.add('selected');
                const t = this.dataset.type;
                state.setState('buckleType', t);
                filter.setBuckleTypeFilter(t);
                renderBuckleMaterialFilter(allBuckles);
            });
        });

        // 初始化材质过滤器
        renderBuckleMaterialFilter(allBuckles);
    }

    function renderBuckleMaterialFilter(allBuckles) {
        const container = document.getElementById('buckle-material-filter-row');
        if (!container) return;

        // 从当前筛选后的扣头中提取材质
        const filtered = filter.getFilteredBuckles();
        const materials = [...new Set(
            (allBuckles.length ? allBuckles : filtered)
                .map(b => b.metafields.buckle_material)
                .filter(Boolean)
        )].sort();

        if (materials.length === 0) {
            container.style.display = 'none';
            return;
        }

        container.style.display = '';
        const currentMaterial = state.getState().buckleMaterialFilter || '';

        container.innerHTML = `
            <div class="step-section-label" style="margin-top:20px;">SELECT MATERIAL</div>
            <div class="buckle-material-pills">
                <button class="material-pill ${!currentMaterial ? 'selected' : ''}" data-material="">All</button>
                ${materials.map(m => `
                    <button class="material-pill ${currentMaterial === m ? 'selected' : ''}" data-material="${m}">${m}</button>
                `).join('')}
            </div>`;

        container.querySelectorAll('.material-pill').forEach(btn => {
            btn.addEventListener('click', function() {
                container.querySelectorAll('.material-pill').forEach(b => b.classList.remove('selected'));
                this.classList.add('selected');
                const mat = this.dataset.material;
                state.setState('buckleMaterialFilter', mat);
                filter.setBuckleMaterialFilter(mat);
                renderBuckleList(filter.getFilteredBuckles());
            });
        });
    }

    function renderBuckleList(items) {
        const container = document.getElementById('buckle-list');
        if (!container) return;

        const thicknessSection = document.getElementById('thickness-section');
        if (thicknessSection) {
            const selectedBuckleId = state.getState().buckleVariantId;
            const hasSelectedBuckle = selectedBuckleId && items.some(v => String(v.id) === String(selectedBuckleId));
            thicknessSection.style.display = hasSelectedBuckle ? '' : 'none';
        }
        
        renderProductGrid(container, items, 'buckle');
    }

    // ── Product Grid (shared) ────────────────────────────────────────────────

    function renderProductGrid(container, items, type) {
        if (!container) return;
        container.__sourceItems = items;
        container.__sourceType = type;
        clearPaginationControls(container);

        if (!items || items.length === 0) {
            container.innerHTML = '<div class="empty-state">No products found</div>';
            return;
        }

        const groups = groupByProduct(items);
        const selectedVariantId = type === 'buckle'
            ? state.getState().buckleVariantId
            : state.getState().strapVariantId;
        const isMobile = isMobileViewport();
        const pageSize = isMobile ? groups.length : 10;
        const totalPages = Math.max(1, Math.ceil(groups.length / pageSize));
        const currentPage = Math.max(1, Math.min(Number(container.dataset.page || 1), totalPages));
        container.dataset.page = String(currentPage);

        const startIndex = (currentPage - 1) * pageSize;
        const pageGroups = groups.slice(startIndex, startIndex + pageSize);
        let html = '';

        pageGroups.forEach(group => {
            const hasStock = group.variants.some(v => v.available !== false);
            const imgSrc = group.image || '';
            const priceDisplay = group.price > 0 ? '$' + group.price.toFixed(2) : '-';
            const colorMeta = group.variants[0].metafields.strap_color || group.variants[0].metafields.buckle_color || '';
            const isSelectedGroup = selectedVariantId && group.variants.some(v => String(v.id) === String(selectedVariantId));

            html += `
                <div class="product-card ${isSelectedGroup ? 'selected' : ''}" data-product-key="${group.key}" data-type="${type}">
                    <div class="product-image-wrapper">
                        ${imgSrc
                            ? `<img src="${imgSrc}" alt="${group.key}" class="product-image" loading="lazy"/>`
                            : `<div class="product-image-placeholder"></div>`}
                        ${!hasStock ? '<div class="product-badge-oos">Out of Stock</div>' : ''}
                    </div>
                    <div class="product-info">
                        <div class="product-info-row">
                            <h4 class="product-title">${group.key}</h4>
                            ${colorMeta ? `<span class="product-color-dot" style="background:${colorToHex(colorMeta)}" title="${colorMeta}"></span>` : ''}
                        </div>
                        <p class="product-price">${priceDisplay}</p>
                    </div>
                </div>
            `;
        });

        container.innerHTML = html;
        attachGroupClickHandlers(container, pageGroups, type);

        if (!isMobile && totalPages > 1) {
            renderPaginationControls(container, currentPage, totalPages);
        }
    }

    function colorToHex(colorName) {
        const map = { black:'#1a1a1a', brown:'#7B4F2E', tan:'#C4945A', cognac:'#9B4E1A', navy:'#1B2A4A', grey:'#888', gray:'#888', white:'#f5f5f5', burgundy:'#6D1A2A', olive:'#6B7C3C', red:'#c0392b', blue:'#2980b9', green:'#27ae60', gold:'#C9A84C', silver:'#aaa' };
        return map[colorName.toLowerCase().split(' ')[0]] || '#ccc';
    }

    function attachGroupClickHandlers(container, groups, type) {
        container.querySelectorAll(`.product-card[data-type="${type}"]`).forEach(card => {
            card.addEventListener('click', function() {
                const key = this.dataset.productKey;
                const group = groups.find(g => g.key === key);
                if (!group) return;
                if (group.variants.length === 1) {
                    selectVariant(group.variants[0], type, card);
                } else {
                    showVariantPicker(group, type, card, container);
                }
            });
        });
    }

    function selectVariant(variant, type, card) {
        if (variant.available === false) return;
        document.querySelectorAll('.product-card').forEach(c => c.classList.remove('selected'));
        if (card) card.classList.add('selected');
        if (type === 'strap') {
            builder.selectStrap(variant);
        } else {
            builder.selectBuckle(variant);
        }
    }

    function showVariantPicker(group, type, card, container) {
        document.querySelectorAll('.variant-picker-popup').forEach(p => p.remove());

        const popup = document.createElement('div');
        popup.className = 'variant-picker-popup';

        let optHtml = group.variants.map(v => {
            const size = v.metafields.strap_width || v.metafields.buckle_width || v.title.split(' / ')[0] || '';
            const length = v.metafields.strap_length || v.title.split(' / ')[2] || '';
            const label = [size, length].filter(Boolean).join(' / ') || v.title;
            const dis = v.available === false ? 'disabled' : '';
            return `<button class="variant-option-btn ${dis}" data-variant-id="${v.id}" ${dis}>${label}</button>`;
        }).join('');

        popup.innerHTML = `
            <div class="variant-picker-inner">
                <div class="variant-picker-header">
                    <span>${group.key}</span>
                    <button class="variant-picker-close">✕</button>
                </div>
                <div class="variant-picker-options">${optHtml}</div>
            </div>`;

        document.body.appendChild(popup);

        popup.querySelector('.variant-picker-close').addEventListener('click', () => popup.remove());
        setTimeout(() => {
            document.addEventListener('click', function handler(e) {
                if (!popup.contains(e.target) && !card.contains(e.target)) {
                    popup.remove();
                    document.removeEventListener('click', handler);
                }
            });
        }, 0);

        popup.querySelectorAll('.variant-option-btn:not([disabled])').forEach(btn => {
            btn.addEventListener('click', e => {
                e.stopPropagation();
                const v = group.variants.find(v => String(v.id) === btn.dataset.variantId);
                if (v) { popup.remove(); selectVariant(v, type, card); }
            });
        });
    }

    function scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // ── Thickness Grid ───────────────────────────────────────────────────────

    const ALL_THICKNESSES = ['3mm', '4mm', '4.5mm', '5mm', '5.5mm', '6mm', '7mm', '8mm'];

    function renderThicknessGrid(maxThickness) {
        const section = document.getElementById('thickness-section');
        const container = document.getElementById('thickness-grid');
        if (!section || !container) return;

        section.style.display = 'block';

        const currentThickness = state.getState().strapThickness;
        const maxVal = maxThickness ? parseFloat(maxThickness) : 999;

        container.innerHTML = ALL_THICKNESSES.map(t => {
            const val = parseFloat(t);
            const disabled = val > maxVal;
            return `<div class="thickness-card ${disabled ? 'thickness-disabled' : ''} ${currentThickness === t ? 'selected' : ''}"
                         data-thickness="${t}" ${disabled ? 'aria-disabled="true"' : ''}>
                <span class="thickness-label">${t}</span>
                ${disabled ? '<span class="thickness-na">N/A</span>' : ''}
            </div>`;
        }).join('');

        container.querySelectorAll('.thickness-card').forEach(card => {
            card.addEventListener('click', function() {
                if (this.classList.contains('thickness-disabled')) return;
                container.querySelectorAll('.thickness-card').forEach(c => c.classList.remove('selected'));
                this.classList.add('selected');
                state.setState('strapThickness', this.dataset.thickness);
            });
        });
    }

    function isMobileViewport() {
        if (typeof window === 'undefined') return false;
        if (window.matchMedia) {
            return window.matchMedia('(max-width: 767px)').matches;
        }
        return window.innerWidth <= 767;
    }

    function clearPaginationControls(container) {
        const pagerId = `${container.id}-pagination`;
        const existing = document.getElementById(pagerId);
        if (existing) existing.remove();
    }

    function renderPaginationControls(container, currentPage, totalPages) {
        const pagerId = `${container.id}-pagination`;
        clearPaginationControls(container);

        const pager = document.createElement('div');
        pager.id = pagerId;
        pager.className = 'product-pagination';
        pager.innerHTML = `
            <button class="pagination-btn" data-page-action="prev" ${currentPage <= 1 ? 'disabled' : ''}>Previous</button>
            <span class="pagination-status">Page ${currentPage} / ${totalPages}</span>
            <button class="pagination-btn" data-page-action="next" ${currentPage >= totalPages ? 'disabled' : ''}>Next</button>
        `;

        pager.querySelectorAll('[data-page-action]').forEach(btn => {
            btn.addEventListener('click', function() {
                const action = this.dataset.pageAction;
                const page = Number(container.dataset.page || 1);
                const nextPage = action === 'prev' ? page - 1 : page + 1;
                if (nextPage < 1 || nextPage > totalPages) return;
                container.dataset.page = String(nextPage);
                renderProductGrid(container, container.__sourceItems || [], container.__sourceType || 'strap');
            });
        });

        container.insertAdjacentElement('afterend', pager);
    }

    return { renderProductGrid, renderStrapStep, renderBuckleStep, renderInnerStrapColorCards, renderThicknessGrid, scrollToTop };
})();
